import { sortByDate } from "@/functions/sortByDate";
import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "../../.sourceflow/podcast.json";

export const usePodcast = ({ limit = null } = {}) => {
  const raw = useSourceFlowCollection(data.category_values || []);

  // console.log("🎧 usePodcast fetched:", raw);

  const collection = sortByDate(raw, "date");

  if (limit) {
    return collection.slice(0, limit);
  }

  return collection;
};

export default usePodcast;
